import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { buildWhatsAppUrl } from "@/lib/site";

const FloatingWhatsApp = () => {
  const { lang } = useLang();
  const href = buildWhatsAppUrl("info", lang);
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      aria-label="WhatsApp"
      className="fixed bottom-6 right-6 z-40 group"
    >
      <span className="absolute inset-0 rounded-full bg-ink/30 blur-xl scale-110 opacity-0 group-hover:opacity-100 transition-opacity" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-ink text-cream border border-cream/20 hover:bg-cream hover:text-ink transition-colors duration-500">
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden
        >
          <path
            d="M12.04 2C6.58 2 2.14 6.44 2.14 11.9c0 2.1.66 4.05 1.78 5.64L2 22l4.6-1.88a9.86 9.86 0 0 0 5.44 1.62h.01c5.46 0 9.9-4.44 9.9-9.9 0-2.65-1.03-5.13-2.9-7-1.87-1.87-4.36-2.84-7.01-2.84zm0 18.16h-.01a8.27 8.27 0 0 1-4.6-1.37l-.33-.21-2.73 1.12.83-2.66-.22-.34a8.27 8.27 0 0 1-1.41-4.6c0-4.55 3.7-8.25 8.27-8.25 2.21 0 4.28.86 5.84 2.42a8.24 8.24 0 0 1 2.41 5.84c-.01 4.55-3.71 8.05-8.05 8.05zm4.53-6.18c-.25-.13-1.46-.72-1.69-.8-.23-.08-.39-.13-.55.13-.16.25-.63.8-.78.96-.14.16-.29.18-.54.06-.25-.13-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.39.11-.51.11-.11.25-.29.38-.43.13-.14.17-.25.25-.41.08-.16.04-.31-.02-.43-.06-.13-.55-1.34-.76-1.83-.2-.48-.4-.41-.55-.42-.14-.01-.31-.01-.47-.01-.16 0-.43.06-.66.31-.23.25-.86.84-.86 2.05 0 1.21.88 2.37 1 2.54.13.16 1.74 2.66 4.22 3.73.59.25 1.05.41 1.41.52.59.19 1.13.16 1.55.1.47-.07 1.46-.6 1.66-1.17.2-.58.2-1.07.14-1.17-.06-.11-.22-.16-.47-.29z"
            fill="currentColor"
          />
        </svg>
      </span>
    </a>
  );
};

export default FloatingWhatsApp;
